// The free tools, as the tools hub and the products page list them.
import { Calculator, CheckSquareOffset, type Icon, Gauge, Thermometer } from "@phosphor-icons/react";

export interface Tool {
  to: string;
  name: string;
  line: string;
  Icon: Icon;
}

export const TOOLS: Tool[] = [
  { to: "/tools/meter", name: "The Meter", line: "Estimate what a prompt might cost before you press send.", Icon: Gauge },
  { to: "/tools/guard-savings", name: "Guard savings", line: "What a pre-execution guard saves a scheduled automation.", Icon: Calculator },
  { to: "/tools/danger-scale", name: "Danger Scale", line: "Six levels for what an agent may do, and who must say yes.", Icon: Thermometer },
  { to: "/tools/validator", name: "Workflow validator", line: "Check a portable workflow and watch it run.", Icon: CheckSquareOffset },
];
